import React from 'react';
import PropTypes from 'prop-types';

import { Text } from 'components/core/Typography';
import { Link } from 'components/core/Link';
import { Container } from 'components/core/Page';

import './StateNavLinks.scss';

export default function StateNavLinks({ location }) {
	return (
		<div className="state-nav-links">
			<Container className="links-container">
				<Link href="#self-storage">
					<Text
						className="nav-link"
						color="white"
						size="medium"
					>
						{location.fullState} Self-Storage
					</Text>
				</Link>
				<Link href="#reasons">
					<Text
						className="nav-link"
						color="white"
						size="medium"
					>
						Reasons to Move to {location.fullState}
					</Text>
				</Link>
				<Link href="#moving">
					<Text
						className="nav-link"
						color="white"
						size="medium"
					>
						Moving to {location.fullState}
					</Text>
				</Link>
				<Link href="#economic-outlook">
					<Text
						className="nav-link"
						color="white"
						size="medium"
					>
						Economic Outlook
					</Text>
				</Link>
				<Link href="#places">
					<Text
						className="nav-link"
						color="white"
						size="medium"
					>
						Places to Live
					</Text>
				</Link>
				<Link href="#resources">
					<Text
						className="nav-link"
						color="white"
						size="medium"
					>
						Resources
					</Text>
				</Link>
			</Container>
		</div>
	);
}

StateNavLinks.propTypes = {
	location: PropTypes.shape({
		state: PropTypes.string.isRequired,
		fullState: PropTypes.string.isRequired,
	}).isRequired,
};
